import { Col, Row, Modal, notification } from 'antd'

import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import {
  clear,
  submitAssessment
} from '../../../reducers/assessmentCreationReducer'

import { useNavigate, useParams } from 'react-router'

import AssessmentOptionsMenu from './AssessmentOptionsMenu'
import AssessmentQuestionsSection from './AssessmentQuestionsSection'

const AssessmentCreation = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { courseId } = useParams()

  const assessmentType = props.assessmentType

  const questions = useSelector((state) => state.assessmentCreation.questions)
  const [title, setTitle] = useState('Assessment Title')

  const [controlledQuestionType, setControlledQuestionType] = useState('online')

  const [files, setFiles] = useState([])

  useEffect(() => {
    return () => {
      dispatch(clear())
    }
  }, [dispatch])

  const handlecontrolledQuestionType = (value) => {
    setControlledQuestionType(value)
  }

  const handleSubmit = (values) => {
    const openTime = values.time?.[0]?.toISOString()
    const closeTime = values.time?.[1]?.toISOString()
    const check = questions.filter((question) => question.status === 'DRAFT')

    if (check.length > 0 && values.questionsType === 'online') {
      Modal.info({
        title: 'Unsaved Questions',
        content: 'save all questions before submitting'
      })
      return
    }

    if (title.trim() === '' || title === '') {
      return notification.error({
        message: 'Title cannot be empty',
        description: 'Please provide a valid title for the assessment.'
      })
    }

    if (
      (values.questionsType === 'online' &&
        questions.filter((q) => q.status !== 'DRAFT').length === 0) ||
      (values.questionsType === 'file' && files.length === 0)
    ) {
      return notification.error({
        message: 'Assessment cannot be empty',
        description:
          'Please add at least one question or upload a file before creating the assessment.'
      })
    }

    const baseAssessmentData = {
      title: title,
      ...values,
      type: assessmentType,
      course: courseId,
      questions:
        values.questionsType === 'online'
          ? questions.filter((question) => question.status !== 'DRAFT')
          : [],
      openAt: openTime,
      closeAt: closeTime,
      time: undefined,
      dueDate:
        assessmentType === 'Assignment' && values.dueDate
          ? values.dueDate.toISOString()
          : undefined
    }

    let payloadToSend

    const formData = new FormData()
    if (values.questionsType === 'file' && files.length > 0) {
      files.forEach((file, index) => {
        if (file.originFileObj) {
          formData.append('files', file.originFileObj)
        }
      })
    }
    formData.append('assessmentData', JSON.stringify(baseAssessmentData))
    payloadToSend = formData

    dispatch(submitAssessment(courseId, payloadToSend)).then(() => {
      const location = assessmentType === 'Exam' ? 'exams' : 'assignments'
      navigate(`/app/course/${courseId}/${location}`)
    })
  }

  const getMaxScore = () => {
    return questions.reduce((acumalator, item) => {
      if (item.points) return acumalator + item.points
      return acumalator
    }, 0)
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={18}>
        <AssessmentQuestionsSection
          controlledQuestionType={controlledQuestionType}
          files={files}
          setFiles={setFiles}
          questions={questions}
          title={title}
          setTitle={setTitle}
        />
      </Col>

      <Col span={6}>
        <AssessmentOptionsMenu
          controlledQuestionType={controlledQuestionType}
          handlecontrolledQuestionType={handlecontrolledQuestionType}
          assessmentType={assessmentType}
          maxScore={getMaxScore()}
          handleSubmit={handleSubmit}
        />
      </Col>
    </Row>
  )
}

export default AssessmentCreation
